import axios from "axios";

/**
 * Simple wrapper around axios.get - no caching at all.
 * Just passes through to axios with withCredentials.
 */
export async function cachedGet(url, params = {}, axiosOptions = {}) {
    return axios.get(url, {
        params,
        withCredentials: true,
        ...axiosOptions
    });
}

export function clearApiCache() {
    // No-op, no cache to clear
}